// extracted by mini-css-extract-plugin
export default {"Contact":"Contact_Contact__+3W11","List":"Contact_List__j2QYN","MediaList":"Contact_MediaList__Cyvlu","Media":"Contact_Media__kP34C"};